import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_ESTIMATES_REFRESH: createSagaAction('JOB_ESTIMATES_REFRESH'),

  JOB_ESTIMATE_CREATE: createSagaAction('JOB_ESTIMATE_CREATE'),
  JOB_ESTIMATE_UPDATE: createSagaAction('JOB_ESTIMATE_UPDATE'),
  JOB_ESTIMATE_DELETE: createSagaAction('JOB_ESTIMATE_DELETE'),

  GET_JOB_ESTIMATE_SECTIONS: createSagaAction('GET_JOB_ESTIMATE_SECTIONS'),
  GET_JOB_ESTIMATE_ITEMS: createSagaAction('GET_JOB_ESTIMATE_ITEMS')
}

// Action Creators
export const actions = {
  jobEstimatesRefresh: ({ jobId }) => ({
    type: constants.JOB_ESTIMATES_REFRESH.ACTION,
    jobId
  }),

  createJobEstimate: ({
    jobId,
    content,
    estimateGroups,
    estimateItems,
    estimateCounts,
    userId
  }) => ({
    type: constants.JOB_ESTIMATE_CREATE.ACTION,
    jobId,
    content,
    estimateGroups,
    estimateItems,
    estimateCounts,
    userId
  }),

  updateJobEstimate: ({
    jobId,
    estimateId,
    content,
    estimateGroups,
    estimateItems,
    estimateCounts,
    userId
  }) => ({
    type: constants.JOB_ESTIMATE_UPDATE.ACTION,
    jobId,
    estimateId,
    content,
    estimateGroups,
    estimateItems,
    estimateCounts,
    userId
  }),

  deleteJobEstimate: ({ estimateId, jobId }) => ({
    type: constants.JOB_ESTIMATE_DELETE.ACTION,
    jobId,
    estimateId
  }),

  getJobEstimateSections: estimateId => ({
    type: constants.GET_JOB_ESTIMATE_SECTIONS.ACTION,
    estimateId
  }),

  getJobEstimateItems: estimateId => ({
    type: constants.GET_JOB_ESTIMATE_ITEMS.ACTION,
    estimateId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_ESTIMATES_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_ESTIMATES_REFRESH.SUCCESS:
      return {
        ...state,
        jobEstimates: action.payload
      }
    case constants.JOB_ESTIMATES_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_ESTIMATE_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_ESTIMATE_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_ESTIMATE_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_JOB_ESTIMATE_SECTIONS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_JOB_ESTIMATE_SECTIONS.SUCCESS:
      return {
        ...state,
        jobEstimateSections: action.payload
      }
    case constants.GET_JOB_ESTIMATE_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_JOB_ESTIMATE_ITEMS.SUCCESS:
      return {
        ...state,
        jobEstimateItems: action.payload
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobEstimateActions.js